import { assertIsNumberOrNull } from '../../helpers/numberHelpers';
import { DesignManifoldDetailsFormModel } from '../shared/quote-or-design-form/manifolds/designManifoldDetailsFormModel';

export type CreateUpdateDesignManifoldDetailsDto = {
  flowTemperatureInDegreesCelsius: number | null;
  disableNumberOfPortsAndPipesPerPortCalculation: boolean;
  isMountedUpsideDown: boolean;
};

export const mapDesignManifoldDetailsFormModelToDto = (
  formModel: DesignManifoldDetailsFormModel,
): CreateUpdateDesignManifoldDetailsDto => ({
  flowTemperatureInDegreesCelsius: assertIsNumberOrNull(formModel.flowTemperatureInDegreesCelsius),
  disableNumberOfPortsAndPipesPerPortCalculation: formModel.disableNumberOfPortsAndPipesPerPortCalculation,
  isMountedUpsideDown: formModel.isMountedUpsideDown,
});
